import { selectEditorSettingsData } from "../draft-selectors";
import { deleteManyColumnTemplates, updateOrAddDatapointRequests, updateOrAddManyColumnOptionStates, updateOrAddManyColumnTemplates } from "../helpers";
import { formatToColumnTypes } from "components/widgets/grid/grid-column-types";
export const setColumnInVariationReducer = (state, action) => {
    const data = selectEditorSettingsData(state);
    if (!data) {
        return;
    }
    const optionState = data?.columns?.options?.find((option) => option?.id === action?.payload?.id);
    if (!optionState) {
        return;
    }
    Object.assign(optionState, {
        groupId: null,
        isGroup: true,
        variation: true
    });
    const variationsColumns = [
        optionState,
        {
            ...optionState,
            currentPeriod: true,
            datapoint: "",
            groupId: optionState.id,
            id: `${optionState?.id}.currentValue`,
            isGroup: false,
            name: "Current"
        },
        {
            ...optionState,
            datapoint: "",
            groupId: optionState.id,
            id: `${optionState?.id}.previousValue`,
            isGroup: false,
            name: "Previous",
            previousPeriod: true
        },
        {
            ...optionState,
            datapoint: "",
            groupId: optionState.id,
            id: `${optionState?.id}.change`,
            isGroup: false,
            name: "Variation",
            variation: true
        },
        {
            ...optionState,
            datapoint: "",
            groupId: optionState.id,
            id: `${optionState?.id}.changePercent`,
            isGroup: false,
            name: "Variation (%)",
            type: formatToColumnTypes.percent,
            variation: true
        }
    ];
    deleteManyColumnTemplates(state, [action?.payload?.id]);
    updateOrAddDatapointRequests(state, [optionState]);
    updateOrAddManyColumnOptionStates(state, variationsColumns);
    updateOrAddManyColumnTemplates(state, variationsColumns);
};
